import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import AiScheduleEditor from './AiScheduleEditor';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Venue-operator view of their own AI day-plan. Rendered in Settings for
 * `client_type === 'ai'` venues. The super-admin configures the same plan
 * per-venue from the Venues table (AdminAiSchedulePage).
 */
export const AiScheduleCard = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/settings/ai-mode/schedule`);
      setData(r.data);
    } catch { /* silent */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const onSave = async (enabled, schedule) => {
    setSaving(true);
    try {
      const r = await axios.put(`${API}/settings/ai-mode/schedule`, { enabled, schedule });
      setData((prev) => ({ ...prev, ...r.data }));
      return r.data;
    } finally {
      setSaving(false);
    }
  };

  if (loading || !data) {
    return (
      <div className="bg-white/[0.03] border border-white/10 rounded-3xl p-6 flex justify-center" data-testid="ai-schedule-loading">
        <Loader2 className="w-5 h-5 text-gray-500 animate-spin" />
      </div>
    );
  }

  return (
    <AiScheduleEditor
      enabled={data.enabled}
      schedule={data.schedule}
      genres={data.genres || []}
      energies={data.energies || []}
      onSave={onSave}
      saving={saving}
    />
  );
};

export default AiScheduleCard;
